import(/* webpackMode: "eager" */ "/vercel/path0/src/app/quy-trinh/quy-trinh-dao-tao-phong-van/page.tsx");
